
import styled from 'styled-components'

import COLORS from 'constants/colors'


export const Wrap = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
`

export const Product = styled.div`
  a {
    color: ${COLORS.BLACK} !important;
  }
`
